module.exports = __webpack_public_path__ + "static/media/education.458393d5.svg";